import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ParameterTypes } from "../../Helper";
export interface ModelParameters {
  [key: string]: ParameterTypes;
}
interface ModelSetting {
  modelParameters: ModelParameters[];
  saveSuccessCancelPopupState: boolean;
}
const initialState: ModelSetting = {
  modelParameters: [],
  saveSuccessCancelPopupState: false,
};
const modelSettingsStore = createSlice({
  name: "ModelSettingsStore",
  initialState: initialState,
  reducers: {
    setModelParameters: (state, action: PayloadAction<any>) => {
      state.modelParameters = action.payload;
    },
    setParameterForModel: (
      state,
      action: PayloadAction<{ key: any; value: any }>
    ) => {
      state.modelParameters = state.modelParameters.map((item) => {
        const itemKey = Object.keys(item)[0]; // Extract the key from the object
         const existingParameters = item[itemKey];
        if (itemKey === action.payload.key) {
          // Return a new object with the updated parameters
          return { [itemKey]: { ...existingParameters,...action.payload.value } };
        }
        return item;
      });
    },
    applyParameterOnAllModels: (
      state,
      action: PayloadAction< any >
    ) => {
      state.modelParameters = state.modelParameters.map((item) => {
        const key = Object.keys(item)[0];
        const existingParameters = item[key];

        // Merge new parameters into the existing ones
        return {
          [key]: { ...existingParameters, ...action.payload },
        };
      });
    },
    updateSuccessPopupSavingState: (state, action: PayloadAction<boolean>) => {
      state.saveSuccessCancelPopupState = action.payload;
    },
  },
});

export const { setModelParameters,updateSuccessPopupSavingState, setParameterForModel,applyParameterOnAllModels} = modelSettingsStore.actions;
export default modelSettingsStore.reducer;
